import { CardMatch } from "../CardMatch";

export function CardRound({ nameRound, matches }) {
  return (
    <div className="w-full bg-darkCard mt-2 rounded-xl">
      <h1 className=" w-full py-4 px-8 text-[#fff] text-2xl font-semibold">
        {nameRound}
      </h1>
      <div className="px-8 flex flex-col gap-3 pb-5">
        {matches.map((match) => (
          <CardMatch
            key={match.id}
            participants={match.participants}
            datetime={match.startTime}
            state={match.state}
          />
        ))}
      </div>
    </div>
  );
}